// extracted by mini-css-extract-plugin
module.exports = {"plate":"style_plate__BGcbM","old":"style_old__wRhld"};